import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  infoBlock: {
    backgroundColor: theme.palette.gray.aliceGray,
    color: theme.palette.black.main,
    marginTop: 20,
    padding: '.5 rem',
  },
  agreementBlock: {
    paddingLeft: '0.2rem',
    paddingTop: '1rem',
    paddingBottom: '1rem',
    alignItems: 'center',
  },
  root: {
    backgroundColor: theme.palette.gray.aliceGray,
    margin: 0,
    width: '100%',
  },
  invalidAgree: {
    color: theme.palette.error.main,
  },
  agree: {
    color: theme.palette.primary.main,
    marginTop: '0.3rem',
    fontSize: '0.9rem',
  },
  infoText: {
    fontSize: '0.9rem',
    paddingLeft: '0.5rem',
    paddingRight: '0.5rem',
    textAlign: 'justify',
  },
  agreeToTerms: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    width: 'fit-content',
    fontSize: '0.9rem',
  },
  agreeToTermsInvalid: {
    color: theme.palette.error.main,
  },
  invalidCheckbox: {
    color: theme.palette.error.main,
  },
  checkboxAndClaim: {
    display: 'flex',
  },
}));

export default useStyles;
